module.exports = __webpack_public_path__ + "static/media/19_pol_0_84.54.54e7a75c.png";